import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'

import { ResidentAppError } from '../../../common/error'

import { Error } from 'components/Error'

interface FeedbackErrorHandlerProps {
  children: React.ReactNode
}

export const FeedbackErrorHandler: React.FC<FeedbackErrorHandlerProps> = ({
  children,
}) => {
  const [t] = useTranslation(['feedback'])

  const fallbackRender = ({ error }: FallbackProps) => {
    if (error instanceof ResidentAppError) {
      switch (error.errorCode) {
        case 'FEEDBACK_SUBMIT_ERROR':
          return <Error message={t('errors.submitError')} />

        case 'NOT_FOUND':
          return <Error message={t('errors.noFeedbackFound')} />

        default:
          return <Error message={t('errors.serviceUnavailable')} />
      }
    }

    return <Error message={t('errors.serviceUnavailable')} />
  }

  return (
    <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>
  )
}
